<template>
  <div class="main">
    <div class="advert-base-map">
      <!-- <div class="advert-home" @click="goHome()"></div> -->
    </div>
    <div class="advert-content">
      <!-- 登录模块 -->
      <div class="login-box">
        <div class="login-title">账号登录</div>
        <div class="input-item">
          <input
            v-model="formData.userName"
            type="text"
            placeholder="请输入账号"
            maxlength="20"
          />
        </div>
        <div class="input-item">
          <input
            v-model="formData.password"
            type="password"
            placeholder="请输入密码"
            maxlength="20"
          />
        </div>
        <div class="btn-group">
          <button class="login-btn" @click="handleLogin">登录</button>
        </div>
        <div class="tip-text" v-if="errorMsg">{{ errorMsg }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { Notify } from "vant";
import webSite from "../../../api/webSite";
import recharApi from '../../../api/rechargeApi'

export default {
  name: "Advert",
  metaInfo: {
    title: "《群侠传》",
  },
  data() {
    return {
      // 登录表单数据
      formData: {
        userName: '',
        password: ''
      },
      // 错误提示
      errorMsg: ''
    }
  },
  components: {},
  computed: {
    ...mapGetters({
      loginShow: "base/loginShow",
    }),
  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      loginDialog: "base/loginDialog",
    }),
    // 登录弹窗关闭
    loginDialogClose(state) {
      this.loginDialog(state);
    },
    goPay() {
      this.$router.push({ path: "/payment" });
    },
    // 登录逻辑
    async handleLogin() {
      this.errorMsg = ''
      // 表单校验
      if (!this.formData.userName.trim()) {
        this.errorMsg = '请输入账号'
        return
      }
      if (!this.formData.password.trim()) {
        this.errorMsg = '请输入密码'
        return
      }
      try {
        const res = await webSite.orderLogin(this.formData);

        if (res?.code === 200) {
       
            sessionStorage.setItem('orderLogin', '1');
            sessionStorage.setItem('orderUserName', this.formData.userName);
            sessionStorage.setItem('orderPwd', this.formData.password);
            Notify({
              type: 'success',
              message: '登录成功'
            });
            // 跳转
            this.goPay();
        
        } else {
          this.errorMsg = res?.msg || '登录失败，请重试';
        }
      } catch (err) {
        this.errorMsg = err?.message || '登录失败，请检查账号密码';
        console.error('登录错误:', err);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: auto;
  z-index: 1000;

  .advert-base-map {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 150px;
    background: url("~@/assets/image/mb/payment/pay-home01.png");
    background-size: 100% 100%;

    .advert-home {
      width: 65px;
      height: 26px;
      margin-top: 5%;
      margin-left: 1%;
      background: url("../../../assets/image/mb/payment/pay-button.png");
      background-size: 100% 100%;
    }
  }

  .advert-content {
    width: 100%;
    min-height: calc(100vh - 150px);
    display: flex;
    // 调整对齐方式，让模块靠上
    align-items: flex-start;
    justify-content: center;
    padding-top: 80px; // 控制模块距离顶部的位置
    background-color: #fff;

    .login-box {
      // 放大登录框尺寸
      width: 450px;
      padding: 40px 50px;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 6px 30px rgba(230, 67, 67, 0.18);
      border: 1px solid #f0f0f0;
      display: flex;
      flex-direction: column;
      gap: 24px;

      .login-title {
        font-size: 22px;
        font-weight: bold;
        color: #e64343;
        text-align: center;
        margin-bottom: 12px;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 50px;
          height: 3px;
          background: linear-gradient(90deg, #ff6b6b, #e64343);
          border-radius: 2px;
        }
      }

      .input-item {
        width: 100%;
        height: 50px;
        border: 1px solid #e8e8e8;
        border-radius: 10px;
        padding: 0 18px;
        box-sizing: border-box;
        background: #fafafa;
        transition: all 0.3s;

        &:hover,
        &:focus-within {
          border-color: #e64343;
          background: #fff;
          box-shadow: 0 0 0 4px rgba(230, 67, 67, 0.1);
        }

        input {
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
          font-size: 15px;
          color: #333;
          background: transparent;

          &::placeholder {
            color: #999;
          }
        }
      }

      .btn-group {
        width: 100%;
        margin-top: 12px;

        .login-btn {
          width: 100%;
          height: 50px;
          background: linear-gradient(90deg, #ff6b6b, #e64343);
          border: none;
          border-radius: 10px;
          color: #fff;
          font-size: 16px;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s;
          box-shadow: 0 5px 15px rgba(230, 67, 67, 0.3);

          &:hover {
            opacity: 0.9;
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(230, 67, 67, 0.4);
          }

          &:active {
            transform: translateY(0);
            box-shadow: 0 3px 10px rgba(230, 67, 67, 0.3);
          }
        }
      }

      .tip-text {
        font-size: 14px;
        color: #e64343;
        text-align: center;
        line-height: 20px;
        min-height: 20px;
      }
    }
  }
}
</style>